<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Test Barcode</h3>

            <div class="search_bar mb-1">
                <b-card>
                    <b-row class="mb-1">
                        <b-col>
                            Barcode
                        </b-col>
                        <b-col>
                            <b-form-input
                                size="sm"
                                type="text"
                                placeholder=""
                                v-model="code"
                                id="codeInput"
                                @keydown="onKeyDown"
                                v-on:keyup.enter="nextRow()"
                                @paste="onPaste()"
                                ref="codeInputRef"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col>
                            2nd Input
                        </b-col>
                        <b-col>
                            <b-form-input
                                size="sm"
                                type="text"
                                placeholder=""
                                id="testInput"
                                ref="testInputRef"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col>
                            Input Type
                        </b-col>
                        <b-col>
                            <div>{{ inputType }}</div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col>
                            Prev code
                        </b-col>
                        <b-col>
                            <div>{{ prevCode }}</div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col>
                            Current code
                        </b-col>
                        <b-col>
                            <div>{{ code }}</div>
                        </b-col>
                    </b-row>

                    <b-row class="mb-1">
                        <b-col>
                            Event Logs
                        </b-col>
                        <b-col>
                            <div v-for="(item, i) in event_logs" :key="i">
                                <div>
                                    {{ item.event }} triggered, {{ item.time }},
                                    {{ item.content }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="mb-1">
                        <b-col>
                            <h2>Current Camera</h2>
                            <code v-if="device">{{ device.label }}</code>
                            <web-cam
                                ref="webcam"
                                :device-id="deviceId"
                                width="100%"
                                @started="onStarted"
                                @stopped="onStopped"
                                @error="onError"
                                @cameras="onCameras"
                                @camera-change="onCameraChange"
                            />

                            <select v-model="camera">
                                <option>-- Select Device --</option>
                                <option
                                    v-for="device in devices"
                                    :key="device.deviceId"
                                    :value="device.deviceId"
                                    >{{ device.label }}</option
                                >
                            </select>

                            <b-button
                                class="btn-action"
                                size="sm"
                                variant="info"
                                @click="onStart"
                            >
                                Start
                            </b-button>

                            <b-button
                                class="btn-action"
                                size="sm"
                                variant="info"
                                @click="onStop"
                            >
                                Stop
                            </b-button>

                            <b-button
                                class="btn-action"
                                size="sm"
                                variant="info"
                                @click="onCapture"
                            >
                                Capture
                            </b-button>
                        </b-col>
                    </b-row>

                    <b-row>
                        <div class="col-md-6">
                            <h2>Captured Image</h2>
                            <figure class="figure">
                                <img :src="img" class="img-responsive" />
                            </figure>
                        </div>
                    </b-row>
                </b-card>
            </div>
        </b-container>
    </div>
</template>

<script>
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import { WebCam } from "vue-web-cam";
import moment from "moment";

var delay = (function() {
    var timer = 0;
    return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService],
    components: {
        barcode: VueBarcode,
        WebCam
    },
    data() {
        return {
            inputType: "",
            code: "",
            prevCode: "",
            prevCodeText: "",
            event_logs: [],
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            timeout: null
        };
    },
    computed: {
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },
    created() {},
    watch: {
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        }
    },
    methods: {
        onKeyDown(event) {
            console.log(event)
            if (event.key === 'Enter') return;
            
            if (!this.timeout) {
                let prev_code = this.code;
                this.prevCode = prev_code;
                this.timeout = setTimeout(() => {
                    let diff = this.code.length - prev_code.length;
                    this.event_logs = [
                        ...this.event_logs,
                        {
                            event: "Check length diff",
                            time: moment().format("HH:mm:ss"),
                            content: diff
                        }
                    ];
                    if (diff >= 8) {
                        this.inputType = "Barcode";
                    } else {
                        this.inputType = "Keyboard";
                    }
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }, 100);
            }
            this.event_logs = [
                ...this.event_logs,
                {
                    event: "Key down",
                    time: moment().format("HH:mm:ss"),
                    content: this.code + " " + event.code
                }
            ];
        },
        onKeyUp() {
            this.event_logs = [
                ...this.event_logs,
                {
                    event: "Key up",
                    time: moment().format("HH:mm:ss"),
                    content: this.code
                }
            ];
        },
        delayCallback() {
            console.log(this.prevCode, this.code);

            if (this.code.length - this.prevCode.length < 8) {
                this.inputType = "Keyboard";
            } else {
                this.inputType = "Barcode";
            }

            // if (this.code.length < 8) {
            //     this.code = "";
            // }
        },
        onPaste() {
            // this.inputType = "Clipboard paste";
        },
        onCapture() {
            this.img = this.$refs.webcam.capture();
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        },
        nextRow() {
            this.$refs.testInputRef.$el.focus();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/CmsTestBarcodeReader.vue